(() => {
  function initLanoxNavbar(root = document) {
    root.querySelectorAll('[data-lanox-navbar]').forEach((nav) => {
      if (!nav || nav.dataset.lanoxNavInitialized === 'true') return;
      nav.dataset.lanoxNavInitialized = 'true';

      const toggle = nav.querySelector('[data-lanox-nav-toggle]');
      const navLinks = nav.querySelector('.nav-links');
      const dropdowns = nav.querySelectorAll('[data-nav-dropdown]');
      const seriesGroups = nav.querySelectorAll('[data-nav-series-group]');
      let ticking = false;

      const updateNavbar = () => {
        nav.classList.toggle('scrolled', window.scrollY > 48);
        ticking = false;
      };

      const handleScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateNavbar);
      };

      updateNavbar();
      window.addEventListener('scroll', handleScroll, { passive: true });

      const closeDropdowns = (except) => {
        dropdowns.forEach((dropdown) => {
          if (except && dropdown === except) return;
          dropdown.removeAttribute('open');
          const summary = dropdown.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        });
      };

      dropdowns.forEach((dropdown) => {
        const summary = dropdown.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', String(dropdown.hasAttribute('open')));
        }

        dropdown.addEventListener('toggle', () => {
          if (dropdown.open) {
            closeDropdowns(dropdown);
          }

          if (summary) {
            summary.setAttribute('aria-expanded', String(dropdown.open));
          }
        });
      });

      seriesGroups.forEach((group) => {
        const preview = group.querySelector('[data-nav-series-preview]');
        const previewImg = preview?.querySelector('img');
        const previewTitle = preview?.querySelector('.nav-series-preview__title');
        const links = group.querySelectorAll('.nav-dropdown-list a[data-preview-image]');

        if (!preview || !previewImg || !previewTitle || !links.length) return;

        const defaultImage = preview.dataset.defaultImage || previewImg.getAttribute('src') || '';
        const defaultTitle = preview.dataset.defaultTitle || previewTitle.textContent || '';

        const setPreview = (link, options = {}) => {
          const { active = true } = options;
          const nextImage = link?.dataset.previewImage || defaultImage;
          const nextTitle = link?.dataset.previewTitle || defaultTitle;

          if (nextImage) {
            previewImg.setAttribute('src', nextImage);
            previewImg.setAttribute('alt', nextTitle);
          }

          previewTitle.textContent = nextTitle;
          links.forEach((item) => item.classList.toggle('is-preview-active', active && item === link));
        };

        const restorePreview = () => {
          setPreview(null, { active: false });
        };

        restorePreview();

        links.forEach((link) => {
          link.addEventListener('mouseenter', () => setPreview(link));
          link.addEventListener('focus', () => setPreview(link));
        });

        const list = group.querySelector('.nav-dropdown-list');
        list?.addEventListener('mouseleave', restorePreview);
        group.addEventListener('focusout', () => {
          window.requestAnimationFrame(() => {
            if (!group.contains(document.activeElement)) restorePreview();
          });
        });
      });

      if (!toggle || !navLinks) return;

      const setMenuState = (isOpen) => {
        nav.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', String(isOpen));
        if (!isOpen) closeDropdowns();
      };

      toggle.addEventListener('click', () => {
        setMenuState(!nav.classList.contains('is-open'));
      });

      toggle.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setMenuState(!nav.classList.contains('is-open'));
        }
      });

      nav.querySelectorAll('.nav-links a').forEach((link) => {
        link.addEventListener('click', () => setMenuState(false));
      });

      document.addEventListener('click', (event) => {
        if (!nav.contains(event.target)) {
          closeDropdowns();
          setMenuState(false);
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeDropdowns();
          setMenuState(false);
        }
      });
    });
  }

  const boot = (root = document) => {
    initLanoxNavbar(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();
